<div class="snackbar" *ngIf="isVisible" [ngClass]="type">
    <div class="snackbar-icon">
      <svg *ngIf="type === 'success'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.999 14.413-3.713-3.705 1.414-1.414 2.299 2.295 5.294-5.294 1.414 1.414-6.708 6.704z"></path>
      </svg>
      <svg *ngIf="type === 'error'" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    </div>
    <div class="snackbar-content">
      <div class="snackbar-title">{{ title }}</div>
      <div class="snackbar-message">{{ message }}</div>
    </div>
    <div class="snackbar-close" (click)="hide()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
        <path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path>
      </svg>
    </div>
  </div>
  